import React, { useContext, useEffect, useState } from "react";
import "../../Tabels/Tabels.css";
import Table from "react-bootstrap/Table";
import { Toaster } from "react-hot-toast";

import Header from "../../Header/Header";
import { Context } from "../../../../utils/context";
import { Permission } from "../../../../utils/permissions";
import { EditButton } from "../../../common/Button";
import EditOffCanvance from "./Edit";

// Strategies are seeded: they can be viewed and edited, never added or deleted.
const Tables = () => {
  const { getData, IMG_URL, isAllow } = useContext(Context);

  const [data, setData] = useState([]);
  const [show, setShowEdit] = useState(0);

  const getDataAll = async () => {
    const response = await getData("/masters/strategy");
    setData(response?.data || []);
  };

  useEffect(() => {
    getDataAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const canEdit = isAllow?.includes(Permission.Strategy.Edit.name);

  return (
    <>
      <div className="main-advancedashboard">
        <Header title={"Strategy"} link={"/masters/strategy"} />
        <section className="AdvanceDashboard">
          <div className="col-xxl-12 col-xl-12">
            <section className="Tabels tab-radio mt-3">
              <div className="row mt-3">
                <div className="data table-responsive">
                  <Table striped bordered hover responsive center>
                    <thead>
                      <tr>
                        <th className="sr">Sr. No.</th>
                        <th className="tax-name">Image</th>
                        <th className="tax-name">Title</th>
                        <th className="tax-name">Description</th>
                        <th className="tax-name">Win Ratio</th>
                        {canEdit && <th className="active">Action</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((d, index) => (
                        <tr key={d?.id}>
                          <td>{index + 1}.</td>
                          <td>
                            {d?.image ? (
                              <img
                                src={IMG_URL + d.image}
                                alt={d?.title}
                                style={{
                                  width: "80px",
                                  height: "50px",
                                  objectFit: "cover",
                                  borderRadius: "6px",
                                }}
                              />
                            ) : (
                              "-"
                            )}
                          </td>
                          <td>{d?.title}</td>
                          <td
                            style={{
                              maxWidth: "320px",
                              whiteSpace: "pre-wrap",
                              wordBreak: "break-word",
                            }}
                          >
                            {d?.description}
                          </td>
                          <td>{Number(d?.win_ratio)}%</td>
                          {canEdit && (
                            <td>
                              <div className="d-flex">
                                <EditButton
                                  handleShow1={setShowEdit}
                                  id={d?.id}
                                />
                              </div>
                            </td>
                          )}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>
            </section>
          </div>
        </section>
      </div>

      {show ? (
        <EditOffCanvance handleClose={() => setShowEdit(0)} show={show} />
      ) : (
        ""
      )}
      <Toaster position="top-right" />
    </>
  );
};

export default Tables;
